import { createSystemEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICountry } from "../../utils/types/models";

export default createSystemEntityReducer<ICountry>(Endpoint.Countries);
